/**
 * Liveball UI - Readymade Widget Library
 * Developed with jQuery 1.7.2
 * @author Keith Daulton
 */

/**
 * Liveball UI - Widget Modules
 */
(function($) {
	"use strict";
	var console = window.console;
    if ((window.location.search).indexOf("debug=true") < 0) {
        console = {
            log: function() {}
        };
    }

    /**
     * Liveball UI - lightboxflex
     * @constructor
     * @param {String, jQuery, Object} target
     * @param {Object} widget options
     * @returns {Object} returns new lightboxflex object
     *
     */
    LBUI.plugins.lightbox_flex = function(target, options) {
        options = options || {};

        // DATA VARIABLES
        var App,
            eventNamespace = options.instanceId,
            isInit = false,
            isIOS = false,
            stylesheetEle,
            stylesheetIndex,
            stylesheetObj,
            inlineId = 'Popup_'+eventNamespace,
            lightboxEnabled = true,
            tmpls = {
            	// HTML markup of popup, `mfp-close` will be replaced by the close button
				framelessIframe: ['<div class="mfp-iframe-scaler">',
					'<div class="mfp-close"></div>',
					'<div class="mfp-iframe-container">',
						'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>',
					'</div>',
				'</div>'].join(''),
				// HTML markup of popup, `mfp-close` will be replaced by the close button
				framedIframe: ['<div class="mfp-frame">',
					'<div class="mfp-content-inner">',
						'<div class="mfp-iframe-scaler">',
							'<div class="mfp-close"></div>',
							'<div class="mfp-iframe-container">',
								'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>',
							'</div>',
						'</div>',
					'</div>',
				'</div>'].join(''),
				framedImage: ['<div class="mfp-frame">',
					'<div class="mfp-content-inner">',
						'<div class="mfp-close"></div>',
						'<div class="mfp-img"></div>',
						'<div class="mfp-bottom-bar">',
							'<div class="mfp-title"></div>',
							'<div class="mfp-counter"></div>',
						'</div>',
					'</div>',
				'</div>'].join('')
			},
            data = {
                linktype: "text",
                contentType: "url",
                openPdfInNewTab: false,
                frameBorder: false,
                tagValue: "",
                closeBtnEnabled: true,
                closeOnOverlayClick: true
            };

        var paramMap = {
            link_type: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.linktype) {
                        data.linktype = val;
                        updateLinkType();
                    }
                }
            },
            tag_value: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.tagValue) {
                        data.tagValue = val;
                    }
                }
            },
            content_type: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.contentType) {
                        data.contentType = val;
                        updateConfig();
                        updateStyles();
                    }
                }
            },
            content_image: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.contentImage) {
                        data.contentImage = val;
                        updateConfig();
                    }
                }
            },
            overlay_click_close: {
                liveupdate: true,
                callback: function(val) {
                    val = (val == "true") ? true : false;
                    if (val !== data.closeOnOverlayClick) {
                        data.closeOnOverlayClick = val;
                        updateConfig();
                    }
                }
            },
            opacity: {
                liveupdate: true,
                callback: function(val) {
                    val = parseFloat(val);
                    if (val !== data.opacity) {
                        data.opacity = val;
                        updateStyles();
                    }
                }
            },
            overlay_color: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.overlayColor) {
                        data.overlayColor = val;
                        updateStyles();
                    }
                }
            },
            width: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.width) {
                        data.width = parseInt(val, 10);
                        updateStyles();
                    }
                }
            },
            height: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.height) {
                        data.height = parseInt(val, 10);
                        updateStyles();
                    }
                }
            },
            vertical_align: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.verticalAlign) {
                        data.verticalAlign = val;
                        updateConfig();
                    }
                }
            },
            frame_color: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.frameColor) {
                        data.frameColor = val;
                        updateStyles();
                    }
                }
            },
            close_btn_enabled: {
                liveupdate: true,
                callback: function(val) {
                    val = (val == "true") ? true : false;
                    if (val !== data.closeBtnEnabled) {
                        data.closeBtnEnabled = val;
                        updateConfig();
                    }
                }
            },
            close_color: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.closeColor) {
                        data.closeColor = val;
                        updateStyles();
                    }
                }
            },
            frame_enabled: {
                liveupdate: true,
                callback: function(val) {
                    val = (val == "true") ? true : false;
                    if (val !== data.frameBorder) {
                        data.frameBorder = val;
                        updateConfig();
                        updateStyles();
                    }
                }
            },
            frame_thickness: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.frameThickness) {
                        data.frameThickness = val;
                        updateStyles();
                    }
                }
            },
            frame_radius: {
                liveupdate: true,
                callback: function(val) {
                    if (val !== data.frameRadius) {
                        data.frameRadius = val;
                        updateStyles();
                    }
                }
            }
        };

        // ELEMENT VARIABLES
        var $this,
            $lightbox,
            $text,
            $button,
            $image;

        // METHODS
        var toPixels = function(val) {
        	return String(val).indexOf("px") > -1 ? val : val += "px";
        },
        onOpen = function(tag) {
            if (data.verticalAlign === "relative") {
                var offsetTop = $this.offset().top;

                var container = $.magnificPopup.instance.contentContainer;
                var bounds = container[0].getBoundingClientRect();

                offsetTop = Math.max(40, offsetTop - (bounds.height / 2));
                container.offset({ top: offsetTop });
            }
            if (tag) {
                tagClick();
            }
        },
        tagClick = function() {
        	if (data.tagValue != "" && window.liveballTag) {
        		liveballTag(data.tagValue);
        	}
        },
        updateStyleRule = function(selector,decls) {
			if (!selector || !decls) return;

        	var rulesStrs = [],
        		rulesStr;

			if (!stylesheetEle) {
				console.log("lightboxflex: creating style element");
				stylesheetEle = document.createElement('style');
				document.getElementsByTagName('head')[0].appendChild(stylesheetEle);
				// Fix for Safari
				if (!window.createPopup) {
					stylesheetEle.appendChild(document.createTextNode(''));
				}
				stylesheetIndex = document.styleSheets.length - 1;
				stylesheetObj = document.styleSheets[stylesheetIndex];
			}

			for (var i=0,j=decls.length; i<j; i++) {
				var decl = decls[i];
				rulesStrs.push(decl.property + ':' + decl.value + ';');
			}
			console.log('lightboxflex: adding style: \n'+
			selector+' { \n'+
				rulesStrs.join(' \n')+ '\n'+
			'}');

			rulesStr = rulesStrs.join(" ");

			if (stylesheetObj.insertRule) {
				stylesheetObj.insertRule(selector + '{' + rulesStr + '}', stylesheetObj.cssRules.length);
			}else {
				stylesheetObj.addRule(selector, rulesStr, -1);
			}

		},
		updateStyleRules = function(rules) {
			/* [
				{
					selector: "div",
					declarations: [
						{ property: "property", value: "value" }
					]
				}
			] */
			if (!rules) return;
			for(var i=0,j=rules.length; i<j; i++) {
				updateStyleRule(rules[i].selector,rules[i].declarations);
			}
			if (stylesheetObj) console.log(stylesheetObj);
		},
        updateLinkType = function() {
            $text.toggle(data.linktype === "text");
            $button.toggle(data.linktype === "button");
            $image.toggle(data.linktype === "image");
        },
        setConfig = function() {
            var triggerLinks = $this.children('a');

			if (data.contentType === "url" && data.openPdfInNewTab) {
				triggerLinks.attr({
					href: $this.data('href'),
					target: '_blank',
					rel: 'noopener'
				});
				data.configObj = null;
				return;
			}

			if (data.contentType == "text") {
                triggerLinks.attr('href','#'+inlineId);
	            data.configObj = {
	            	delegate: 'a',
					type: 'inline',
					mainClass: eventNamespace,
                    closeOnBgClick: data.closeOnOverlayClick,
                    showCloseBtn: data.closeBtnEnabled,
                    disableOn: function() {
                        return lightboxEnabled;
                    },
					callbacks: {
                        open: function() {
                            onOpen(true);
                        }
                    }
				};
			} else if (data.contentType == "image") {
                triggerLinks.attr('href',data.contentImage);
	            data.configObj = {
					delegate: 'a',
					type: 'image',
					preloader: true,
					mainClass: eventNamespace,
                    closeOnBgClick: data.closeOnOverlayClick,
                    showCloseBtn: data.closeBtnEnabled,
                    disableOn: function() {
                        return lightboxEnabled;
                    },
					callbacks: {
                        open: function() {
                            onOpen(true);
                        }
                    }
				};
				if (data.frameBorder === true) {
					data.configObj.image = {
						markup: tmpls.framedImage
					};
				}
			} else { // data.contentType == "url"
                triggerLinks.attr('href',$this.data('href'));
	            data.configObj = {
					delegate: 'a',
					type: 'iframe',
					iframe: {
						markup: (data.frameBorder == true ? tmpls.framedIframe : tmpls.framelessIframe)
					},
					mainClass: eventNamespace,
                    closeOnBgClick: data.closeOnOverlayClick,
                    showCloseBtn: data.closeBtnEnabled,
					srcAction: 'iframe_src',
                    disableOn: function() {
                        return lightboxEnabled;
                    },
					callbacks: {
                        open: function() {
                            onOpen(false);
                        }
                    }
				};
			}
			if (data.frameBorder === true) {
				data.configObj.mainClass += ' lbui_framed';
			}
			if (data.verticalAlign === "top") {
				data.configObj.alignTop = true;
			} else if (data.verticalAlign === "relative") {
                data.configObj.alignTop = true;
            }
            if (data.closeBtnEnabled !== true) {
                data.configObj.mainClass += ' lbui_no_close';
            }
        },
        updateConfig = function() {
            setConfig();
			if (data.configObj) {
				$lightbox = $($this).magnificPopup(data.configObj);
			}

            if (App && App.plugins) {
                App.plugins.trigger("rmw:reflowed", { instanceId: eventNamespace });
            }
        },
        setStyles = function() {
			var width = parseInt(data.width, 10) || 900,
				height = parseInt(data.height, 10),
				aspectRatio,
				percentHeight,
				opacityFloat = parseFloat(data.opacity),
				opacityNum = opacityFloat * 100,
				closeBarOffset = 22,
				borderWidth,
				frameTopHeight,
				closeHeight,
				strBorderWidth,
				strFrameTopHeight;

			var rules = [],
				borderRule,
				overlayRule,
				closeRule;

			borderRule = {
                selector: ".mfp-wrap."+eventNamespace+" .mfp-frame",
				declarations: []
			};
			closeRule = {
				selector: ".mfp-wrap."+eventNamespace+" .mfp-close",
				declarations: []
			};
			overlayRule = {
				selector: ".mfp-bg."+eventNamespace,
				declarations: [
					{ property: "opacity", value: opacityFloat },
					{ property: "filter", value: "alpha(opacity="+opacityNum+")" }
				]
			};
			if (data.overlayColor && data.overlayColor !== "") {
				overlayRule.declarations.push({ property: "background-color", value: data.overlayColor });
			}
			rules.push(overlayRule);

			if (data.contentType !== "image") {
				rules.push({
					selector: ".mfp-wrap."+eventNamespace+" .mfp-content",
					declarations: [
						{ property: "max-width", value: toPixels(width) }
					]
				});
			}

			if (data.closeColor && data.closeColor !== "") {
				closeRule.declarations.push({
					property: "color",
					value: data.closeColor
				});
			}

			if (data.frameBorder === true) {
				borderWidth = frameTopHeight = parseInt(data.frameThickness, 10) || 10;
				if (frameTopHeight < closeBarOffset) {
					frameTopHeight = closeBarOffset+2;
				}
				closeHeight = toPixels((frameTopHeight - 2));
				strFrameTopHeight = toPixels(frameTopHeight);
				strBorderWidth = toPixels(borderWidth);
			}

			if (data.contentType === "url") {
				aspectRatio = height / width;
				percentHeight = aspectRatio * 100;
				rules.push({
					selector: ".mfp-wrap."+eventNamespace+" .mfp-iframe-scaler",
					declarations: [
						{ property: "padding-top", value: String(percentHeight)+"%" }
					]
				});
				var frameContainerRule = {
					selector: ".mfp-wrap."+eventNamespace+" .mfp-iframe-scaler .mfp-iframe-container", // iframe
					declarations: []
				};
				if (data.frameColor && data.frameColor !== "") {
					frameContainerRule.declarations.push({ property: "background", value: data.frameColor });
				}
				if(isIOS === true) {
					frameContainerRule.declarations.push(
						{ property: "overflow", value: "auto" },
						{ property: "-webkit-overflow-scrolling", value: "touch" }
					);
				}
				if(frameContainerRule.declarations.length > 0) rules.push(frameContainerRule);
			} else if (data.contentType === "text") {
                borderRule.selector = ".mfp-wrap."+eventNamespace+" .white-popup";
            }

			if (data.frameBorder === true && data.frameRadius && data.frameRadius !== "") {
				var strFrameRadius = toPixels(data.frameRadius);
				borderRule.declarations.push(
					{ property: "-moz-border-radius", value: strFrameRadius },
					{ property: "-webkit-border-radius", value: strFrameRadius },
					{ property: "border-radius", value: strFrameRadius }
				);
			}
			if ((data.frameBorder === true || data.contentType === "text") && (data.frameColor && data.frameColor !== "")) {
				borderRule.declarations.push({
					property: "background",
					value: data.frameColor
				});
			}

			if (borderRule && borderRule.declarations.length > 0) rules.push(borderRule);
			if (closeRule && closeRule.declarations.length > 0) rules.push(closeRule);

			updateStyleRules(rules);
		},
        updateStyles = function() {
            setStyles();

            if (App && App.plugins) {
                App.plugins.trigger("rmw:reflowed", { instanceId: eventNamespace });
            }
        },
        destroy = function() {
            // Remove namespaced bindings
            if ($lightbox && $lightbox.close) {
                $lightbox.close();
            }
        },
        set = function(varName, content) {
        /*
            require that all settable (live-updatable) variables conform to the data-liveball-varprops obj:
            {
                "varName": "variableName", // must match the variable's name exactly
                "liveUpdate": false, // default, if not specified, is true
                "clickToEdit": false, // default, if not specified, is true
                "updateTarget": "string" // specific to the rmw's set method(s), and page-editor agnostic. See switch below for example usage.
            }
		*/

            var mapObj = paramMap[varName];

            if (typeof mapObj === 'object') {
                if (mapObj.liveupdate === true) {
                    mapObj.callback(content);
                    return true;
                }
                return false;
            }

            var $target = $this.find('[data-liveball-varprops]').filter(function() {
                var targetData = $(this).data('liveball-varprops');
                return (targetData !== null &&
                        typeof targetData === 'object' &&
                        targetData.varName === varName &&
                        targetData.liveUpdate !== false &&
                        targetData.updateTarget);
            });

            // expect only one set-able target, otherwise abort!
            if ($target.length !== 1 && varName !== 'linklabel') {
                return false;
            }

            switch ($target.data('liveball-varprops').updateTarget) {
                case 'innerHTML':
                    $target.html(content);
                    break;
                case 'src':
                    $target.attr('src', content);
                    break;
                case 'href':
                    $target.attr('href', content);
                    break;
                default:
                    return false;
            }

            return $target.get();
        },
        init = function(target, options) {
            if (!isInit) {
                $this = (target instanceof $) ? target : $(target);

				$.extend(data, options);

				if (data.contentType === "image" && data.contentImage) {
					(new Image()).src = data.contentImage;
				}

                $text = $this.find('[data-linktype="text"]');
                $button = $this.find('[data-linktype="button"]');
                $image = $this.find('[data-linktype="image"]');

                updateLinkType();

				isIOS = (/iphone|ipad|ipod/gi).test(navigator.appVersion);
                setConfig();
                setStyles();

                if ($this.length > 0) {
					if (data.configObj) {
						$lightbox = $($this).magnificPopup(data.configObj);
						$.magnificPopup.instance._setFocus = function() {
							$.magnificPopup.instance.contentContainer.focus();
						};
					}
				}

                isInit = true;
                console.log("lightboxflex: initialized");
            } else {
                console.log("lightboxflex: already initialized");
            }
        },
        registerCreativeStudioEvents = function(app) {
            App = app;
            if (!app || !app.plugins) {
                return;
            }
        };

        $(document).ready(function() {
            init(target, options);
        });

        // EXPOSED
        // 'set' and 'destroy' must be exposed for next-gen functionality in page editor
        return {
            destroy: destroy,
            set: set,
            registerCreativeStudioEvents: registerCreativeStudioEvents,
            enable: function () {
                lightboxEnabled = true;
            },
            disable: function () {
                lightboxEnabled = false;
                $.magnificPopup.close();
            },
            open: function () {
				if (data.openPdfInNewTab) {
					var link = $this.children('a:visible').get(0);
					if (link) {
						link.click();
					}
					return;
				}
				$lightbox.magnificPopup('open');
            },
            close: function () {
                $.magnificPopup.close();
            }
        };
    };
})((window.ixp.runtime.components.dependencies.jQuery.v1_11 || window.jQuery)); // passing jQuery reference to use
